import { GET, POST, PATCH, deleteRequest } from '../configs/api';
import { api } from './constants';

/**
 * @returns {Promise<Array<{ id: string; name: string; created_at?: string }>>}
 */
export async function fetchStoreNameSuggestions() {
  const { data, error } = await GET(api.getStoreNames);
  if (error) return [];
  return Array.isArray(data?.storeNames) ? data.storeNames : [];
}

/**
 * @returns {Promise<{ id: string; name: string; created_at?: string } | null>}
 */
export async function addStoreNameSuggestion(name) {
  const trimmed = typeof name === 'string' ? name.trim() : '';
  if (!trimmed) return null;

  const { data, error } = await POST(api.createStoreName, {}, { name: trimmed });
  if (error) return null;
  return data ?? null;
}

/**
 * @returns {Promise<{ id: string; name: string; created_at?: string } | null>}
 */
export async function updateStoreNameSuggestion(id, name) {
  const trimmed = typeof name === 'string' ? name.trim() : '';
  if (!id || !trimmed) return null;

  const { data, error } = await PATCH(`${api.updateStoreName}/${id}`, {}, { name: trimmed });
  if (error) return null;
  return data ?? null;
}

/**
 * @returns {Promise<boolean>}
 */
export async function removeStoreNameSuggestion(id) {
  if (!id) return false;
  const { error } = await deleteRequest({ url: `${api.deleteStoreName}/${id}` });
  return !error;
}

export function sortStoreNameOptions(options) {
  return [...options].sort((a, b) => a.name.localeCompare(b.name));
}

export function upsertStoreNameOption(options, entry) {
  if (!entry?.id || !entry?.name) return options;
  if (options.some((option) => option.id === entry.id)) return options;
  return sortStoreNameOptions([...options, entry]);
}
